import { scriptInit } from 'redux/reducers/init';
import {
  requestScriptList,
  requestScriptListByScroll,
  requestScriptListByScrollFailure,
  requestScriptListByScrollSuccess,
  requestScriptListFailure,
  requestScriptListSuccess,
  selectScript,
  requestPutScript,
  requestPutScriptSuccess,
  requestPutScriptFailure,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const script = createReducer(scriptInit, {
  [requestScriptList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestScriptListSuccess.type]: (state, action) => {
    const { scriptList, pagination, keyword } = action.payload;
    state.isLoading = false;
    state.scriptList = scriptList;
    state.pagination = pagination;
    state.keyword = keyword;
    state.selectedScript = null;
  },
  [requestScriptListFailure.type]: (state, action) => {
    state.isLoading = false;
    state.scriptList = [];
    state.selectedScript = null;
  },
  [requestScriptListByScroll.type]: (state, action) => {
    state.isLoadingByWheel = true;
  },
  [requestScriptListByScrollSuccess.type]: (state, action) => {
    const { scriptList, pagination } = action.payload;
    state.isLoadingByWheel = false;
    state.scriptList.push(...scriptList);
    state.pagination = pagination;
  },
  [requestScriptListByScrollFailure.type]: (state, action) => {
    state.isLoadingByWheel = false;
    state.scriptList = [];
  },
  [selectScript.type]: (state, action) => {
    const { script } = action.payload;
    state.selectedScript = script;
  },
  [requestPutScript.type]: (state, action) => {
    state.isLoadingPut = true;
  },
  [requestPutScriptSuccess.type]: (state, action) => {
    state.isLoadingPut = false;
    state.message = '스크립트 수정 완료';
    state.putError = false;
  },
  [requestPutScriptFailure.type]: (state, action) => {
    state.isLoadingPut = false;
    state.message = '스크립트 수정 실패';
    state.putError = true;
  },
});

export default script;
